import Image from "components/Image"
import logoPng from "assets/images/logo.png"

function LogoSvg() {
  return <Image src={logoPng} width="60" />
}

export default LogoSvg
